import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-cool-lib4444',
  template: `
    <p>
      cool-lib4444 works!
    </p>
  `,
  styles: []
})
export class CoolLib4444Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
